var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"slideshow"},[_c('AppSingleColumn',{attrs:{"content":_vm.content.description,"index":2}}),_vm._v(" "),_c(_vm.slidesComponent,{tag:"component",attrs:{"slides":_vm.content.slides}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1afdab4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/vuejs/frontend/2023-launch/components/AppSlideShow.vue
// module id = 93bN
// module chunks = 4